import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getFutureEvents = (state: RootState) => state.pages.editor.documents.future.length;

const getRedoEvents = createSelector([getFutureEvents], (events) => events);

export default getRedoEvents;
